// Washing Machine Icon Web Component
class WashingMachineIcon extends HTMLElement {
  constructor() {
    super();
    this.size = this.getAttribute('size') || 'medium'; // small, medium, large
    this.interactive = this.getAttribute('interactive') !== 'false'; // default true
  }

  static get observedAttributes() {
    return ['size', 'interactive'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (name === 'size') {
        this.size = newValue || 'medium';
      } else if (name === 'interactive') {
        this.interactive = newValue !== 'false';
      }
      this.render();
    }
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <div class="washing-machine-container ${this.interactive ? 'interactive' : 'static'}">
        <div class="washing-machine">
          <div class="machine-body">
            <div class="machine-door">
              <div class="machine-drum">
                <div class="drum-inner">
                  <div class="clothes-item"></div>
                  <div class="clothes-item"></div>
                  <div class="clothes-item"></div>
                </div>
              </div>
              <div class="door-handle"></div>
            </div>
            <div class="control-panel">
              <div class="control-button"></div>
              <div class="control-button"></div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Set data attribute for size-specific styling
    this.querySelector('.washing-machine-container').setAttribute('data-size', this.size);
  }

  // Method to trigger spinning animation
  spin() {
    if (this.interactive) {
      const container = this.querySelector('.washing-machine-container');
      container.classList.add('spinning');

      setTimeout(() => {
        container.classList.remove('spinning');
      }, 600);
    }
  }

  // Method to start/stop continuous spinning
  startSpinning() {
    if (this.interactive) {
      const drumInner = this.querySelector('.drum-inner');
      const clothesItems = this.querySelectorAll('.clothes-item');

      drumInner.style.animation = 'gentle-spin 2s linear infinite';
      clothesItems.forEach(item => {
        item.style.animation = 'gentle-tumble 2s linear infinite';
      });
    }
  }

  stopSpinning() {
    if (this.interactive) {
      const drumInner = this.querySelector('.drum-inner');
      const clothesItems = this.querySelectorAll('.clothes-item');

      drumInner.style.animation = '';
      clothesItems.forEach(item => {
        item.style.animation = '';
      });
    }
  }
}

// Register the custom element
customElements.define('washing-machine-icon', WashingMachineIcon);
